import { addToCartTourEvent } from 'analytics/optimizely/events'
import { CHECKOUT_ITEM_TYPE_TOUR_V2 } from 'constants/checkout'
import { dateDifference } from 'lib/datetime/dateUtils'
import * as Analytics from 'analytics/analytics'
import uuidV4 from 'lib/string/uuidV4Utils'
import { unique } from 'lib/array/arrayUtils'

function generateTourV2CheckoutItems(
  offer: Tours.V2Offer,
  startDate: Tours.V2OfferDeparture['startDate'],
  endDate: Tours.V2OfferDeparture['endDate'],
  image: App.Image,
  selectedPurchasableOptions: Map<App.Occupants, Tours.V2OfferPurchasableOption>,
): App.Checkout.TourV2Item[] {
  const { days } = dateDifference(new Date(endDate), new Date(startDate))
  const onlyOnePurchaseOption = unique([...selectedPurchasableOptions.values()]).length == 1
  return Array.from(selectedPurchasableOptions.entries()).map(([occupancy, purchasableOption]) => {
    Analytics.track('add-to-cart-tour', addToCartTourEvent())
    return {
      startDate,
      endDate,
      occupancy,
      image,
      purchasableOption,
      offerId: offer.id,
      duration: days + 1,
      itemId: uuidV4(),
      itemType: CHECKOUT_ITEM_TYPE_TOUR_V2,
      transactionKey: uuidV4(),
      privateRequestKey: offer.privateRequestKey,
      total: purchasableOption.price * occupancy.adults,
      purchasableOptionConfirmed: onlyOnePurchaseOption,
    }
  })
}

export default generateTourV2CheckoutItems
